var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34509 14L7.3544 8.44667C7.76787 8.06329 8 7.5444 8 7.0035C8 6.4626 7.76787 5.94371 7.3544 5.56033L1.33814 0L0 1.23725L6.01563 6.797C6.07488 6.8517 6.10816 6.92587 6.10816 7.00321C6.10816 7.08055 6.07488 7.15472 6.01563 7.20942L0.00695312 12.7628L1.34509 14Z",
    fill: "#030304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.16fae3f88b90e1c027fe5e96aeb470ff.svg";
export { ForwardRef as ReactComponent };